<div class="landing-navbar">
  <header class="landing-header">
    <a class="logo-link" routerLink="/" aria-label="Givo início">
      <img class="logo-img" src="/images/givo-logo-orange.png" alt="Givo" width="160" height="52" />
    </a>
    <div class="landing-header__search">
      <app-people-search-bar [stretch]="true" searchPlaceholder="Encontrar pessoas" />
    </div>
    <nav class="header-nav">
      <button type="button" class="link-login" (click)="openLoginModal()">Login</button>
      <button type="button" class="btn-signup" (click)="openSignupModal()">Criar conta</button>
    </nav>
  </header>

</div>
